<template>
    <div class="main">
        <div class="block" :style="{'right':right+'%'}">
            <p v-show="right===400" @touchstart="$router.push('/mycars')" class="startWork">Начать работу</p>
            <img v-show="right!==0" class="back navigation" src="http://avtopoisk.kz/assets/img/arrow.svg" @touchstart="back"/>
            <img v-show="right!==400" class="next navigation" src="http://avtopoisk.kz/assets/img/arrow.svg" @touchstart="next"/>
                    <div class="pages"  v-for="item in items">
                    <intro-item :label="item.label"
                                :iconUrl="item.iconUrl"
                                :backgroundColor="item.mainColor"
                                :itemsCount="5"
                                :mainColor="item.statusColor"
                                :selectedColor="item.selectedColor"
                                :selectedItem="item.selectedItem"
                                :image="item.backgroundImage"
                    /><intro-status :itemsCount="items.length"/>
                </div>
        </div>
    </div>
</template>

<script>
    import IntroStatus from "./intro-status.vue";
    import IntroItem from  "./intro-item.vue"

    export default {
        components: {IntroStatus,IntroItem},
        name: "intro-page",
        methods:{
            next(){
                if(this.right<400){
                    this.right+=100;
                }
            },
            back(){
                if(this.right>0){
                    this.right-=100;
                }
            }

        },
        data() {
            return {
                right:0,
                items:[
                    {
                        label:"Мобильный сервис для поиска автозапчастей",
                        mainColor:"#01579b",
                        statusColor:"#6ab7ff",
                        selectedColor:"#002171",
                        iconUrl:"http://avtopoisk.kz/assets/img/garage.svg",
                        selectedItem:0,
                        backgroundImage:"http://avtopoisk.kz/assets/img/screens/1.png"
                    },
                    {
                        label:"Добавьте информацию о своем автомобиле",
                        mainColor:"#ab47bc",
                        statusColor:"#df78ef",
                        selectedColor:"#790e8b",
                        iconUrl:"http://avtopoisk.kz/assets/img/carIntro.svg",
                        selectedItem:1,
                        backgroundImage:"http://avtopoisk.kz/assets/img/screens/2.png"
                    },
                    {
                        label:"Находите нужные вам запчасти в нашем сервисе",
                        mainColor:"#66bb6a",
                        statusColor:"#98ee99",
                        selectedColor:"#338a3e",
                        iconUrl:"http://avtopoisk.kz/assets/img/search.svg",
                        selectedItem:2,
                        backgroundImage:"http://avtopoisk.kz/assets/img/screens/3.png"
                    },
                    {
                        label:"Общайтесь с клиентом/заказчиком напрямую",
                        mainColor:"#ffab00",
                        statusColor:"#ffdd4b",
                        selectedColor:"#c67c00",
                        iconUrl:"http://avtopoisk.kz/assets/img/chat.svg",
                        selectedItem:3,
                        backgroundImage:"http://avtopoisk.kz/assets/img/screens/4.png"
                    },
                    {
                        label:"Если вы заказчик - находите новых клиентов через наш сервис",
                        mainColor:"#e57373",
                        statusColor:"#ffa4a2",
                        selectedColor:"#af4448",
                        iconUrl:"http://avtopoisk.kz/assets/img/repair.svg",
                        selectedItem:4,
                        backgroundImage:"http://avtopoisk.kz/assets/img/screens/5.png"
                    }
                ]
            }
        }
    }
</script>

<style scoped>
    .main {
        width: 100%;
        height: 100%;
        overflow: hidden;
        background-color: #e7e4e4;
    }
    .block{
        position: relative;
        width: 500%;
        margin: 0;
        text-align: left;
        transition: right 1s ease;
        -webkit-transition: right 1s ease;
        -moz-transition: right 1s ease;
        -o-transition: right 1s ease;

    }
    .startWork{
        font-size: 18px;
        color:#9e9e9e;
        position: fixed;
        right:0px;
        margin: 5px;
    }
    .navigation{
        font-size:18px;
        width:30px;
        height:30px;
        color: #9e9e9e;
        position: fixed;
        margin-top:50%;
        margin-left: 5px;
        margin-right: 5px;
    }
    .next{
        right:0px;
    }
    .back{
        left:0px;
        -moz-transform: rotate(180deg); /* Для Firefox */
        -ms-transform: rotate(180deg); /* Для IE */
        -webkit-transform: rotate(180deg); /* Для Safari, Chrome, iOS */
        -o-transform: rotate(180deg); /* Для Opera */
        transform: rotate(180deg);
    }
    .firstPage{
        right:100%;
    }
    .pages{
         width: 20%;
        float: left;
    }

</style>